module.exports = __webpack_public_path__ + "img/source-sans-pro-v13-latin-600.dd736060.svg";